import React from "react";
import { RepeatIcon, ClockIcon, SparklesIcon, CompassIcon, BoxIcon } from "lucide-react";
import { problemCards } from "../data/problems";
import { ProblemIcon } from "../types/landing";
const icons: Record<ProblemIcon, BoxIcon> = {
  repeat: RepeatIcon,
  clock: ClockIcon,
  sparkles: SparklesIcon,
  compass: CompassIcon
};
export function ProblemReframe() {
  return <section className="border-t border-white/10 bg-navy-800" data-id="element-166" data-mp="1spzdj0446pl2">
      <div className="mx-auto w-full max-w-5xl px-4 py-14 sm:px-6 sm:py-20" data-id="element-167" data-mp="1dxp8ybg2rxkx">
        <div className="max-w-3xl" data-id="element-168" data-mp="1ir0gyfwmikef">
          <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-169" data-mp="1is1tkotafey9">
            When Math Practice Feels Repetitive, Getting Started Is the Hardest
            Part.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-170" data-mp="18xt12149bm03">
            Whether you are supporting a learner at home or planning a class
            activity, finding something clear, useful and engaging should be
            simple.
          </p>
        </div>

        <ul className="mt-10 grid gap-px overflow-hidden border border-white/10 bg-white/10 sm:grid-cols-2" data-id="element-171" data-mp="3b71btfaxw2je">
          {problemCards.map(card => {
          const Icon = icons[card.icon];
          return <li key={card.id} className="flex items-start gap-3 bg-navy-700 p-5 sm:p-6" data-id="element-172" data-mp="3k3ioimyyc8h9">
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center bg-navy-900 text-brand-cyan ring-1 ring-white/10" aria-hidden="true" data-id="element-173" data-mp="3f7bf2k7ckeuk">
                  <Icon className="h-[18px] w-[18px]" data-id="element-174" data-mp="2ng5clx45m524" />
                </span>
                <p className="text-[15px] font-semibold leading-snug text-white sm:text-base" data-id="element-175" data-mp="316h6o1kaudvw">
                  {card.title}
                </p>
              </li>;
        })}
        </ul>

        <div className="mt-10 border-l-4 border-brand-emerald bg-navy-900 p-5 sm:p-7" data-id="element-176" data-mp="28qg7jqsxxgwk">
          <p className="text-base leading-relaxed text-slate-200 sm:text-lg" data-id="element-177" data-mp="28o3g8n1alu6u">
            <span className="font-pixel text-sm uppercase tracking-[0.1em] text-brand-emerald sm:text-base" data-id="element-178" data-mp="23r39sb0j6pf7">
              Math Made Ready
            </span>{' '}
            turns practice into short visual challenges with a clear goal and a
            satisfying next step.
          </p>
        </div>
      </div>
    </section>;
}